const months = ['січ.', 'лют.', 'бер.', 'квіт.', 'трав.', 'чер.', 'лип.', 'серп.', 'вер.', 'жовт.', 'лист.', 'груд.']

export const getMonth = (monthNumber: string) => months[+monthNumber - 1]
